import { Injectable, Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { Additionalflat } from './additionalflat.model';
import { AdditionalflatService } from './additionalflat.service';
@Injectable()
export class AdditionalflatPopupService {
    private isOpen = false;
    constructor(
        private datePipe: DatePipe,
        private modalService: NgbModal,
        private router: Router,
        private additionalflatService: AdditionalflatService

    ) {}

    open(component: Component, id?: number | any): NgbModalRef {
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;

        if (id) {
            this.additionalflatService.find(id).subscribe((additionalflat) => {
                additionalflat.validFrom = this.datePipe
                    .transform(additionalflat.validFrom, 'yyyy-MM-ddThh:mm');
                additionalflat.updated = this.datePipe
                    .transform(additionalflat.updated, 'yyyy-MM-ddThh:mm');
                additionalflat.created = this.datePipe
                    .transform(additionalflat.created, 'yyyy-MM-ddThh:mm');
                this.additionalflatModalRef(component, additionalflat);
            });
        } else {
            return this.additionalflatModalRef(component, new Additionalflat());
        }
    }

    additionalflatModalRef(component: Component, additionalflat: Additionalflat): NgbModalRef {
        const modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static'});
        modalRef.componentInstance.additionalflat = additionalflat;
        modalRef.result.then((result) => {
            this.router.navigate([{ outlets: { popup: null }}], { replaceUrl: true });
            this.isOpen = false;
        }, (reason) => {
            this.router.navigate([{ outlets: { popup: null }}], { replaceUrl: true });
            this.isOpen = false;
        });
        return modalRef;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/additionalflat/additionalflat-popup.service.ts